import { Fade } from 'react-awesome-reveal';

interface NotableSkillProps {
    name: string;
    mark: number;
}

const NotableSkill = ({ name, mark }: NotableSkillProps) => {
    function renderStars() {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <i
                    className={`fas fa-star ${i <= mark ? 'full' : 'empty'}`}
                    key={`skill${i}`}
                />
            );
        }
        return stars;
    }

    return (
        <div className='col-md-4 notableSkill'>
            <Fade>
                <div>
                    <p>{name}</p>
                    {renderStars()}
                </div>
            </Fade>
        </div>
    );
};

export default NotableSkill;
